import { IAppState } from '../../common/state';
import { EDealType } from '../../types/dealType';
import { FOfferType } from '../../utils/category';
import { getDealType } from '../getDealType';
import { getOfferType } from '../getOfferType';
import { selectIsAgent } from '../user';

/**
 * Определяет, доступен ли баннер Циан.Ипотека для профи.
 */
export function selectIsMortgageBrokerBannerAvailable(state: IAppState): boolean {
  const isBannerEnabled = state.config.get<boolean>('e2e.SerpMortgageBrokerBanner.Enabled');
  const offerType = getOfferType(state);
  const dealType = getDealType(state);
  const isAgent = selectIsAgent(state);

  return Boolean(
    isBannerEnabled &&
      isAgent &&
      (offerType === FOfferType.Flat || offerType === FOfferType.FlatNew || offerType === FOfferType.FlatOld) &&
      dealType === EDealType.Sale,
  );
}
